/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDim1VIcon24Solid = forwardRef('ArrowDim1VIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M10.625 4.82 7.472 7.972a1.375 1.375 0 1 1-1.944-1.944l4.44-4.44a2.875 2.875 0 0 1 4.065 0l4.44 4.44a1.375 1.375 0 0 1-1.945 1.944L13.375 4.82V19.18l3.153-3.153a1.375 1.375 0 0 1 1.945 1.945l-4.44 4.44a2.875 2.875 0 0 1-4.066 0l-4.44-4.44a1.375 1.375 0 1 1 1.945-1.945l3.153 3.153V4.82Z" })));
});
